import "./FunctionalityList.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import FunctionalityListComponentController from "./FunctionalityListComponentController";

export default class FunctionalityListComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = FunctionalityListComponentController;
        this.templateUrl = "/App/Components/Site/SystemsTesting/FunctionalityList/FunctionalityList.html";
    }
}

module("mmManagePortal").component("irFunctionalityList", new FunctionalityListComponent());
